import React from "react";

const WistiaIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.4776 10.9818C40.3358 5.83106 37.4276 4.40002 37.4276 4.40002C37.4276 4.40002 37.571 8.59714 29.8468 9.50338C22.9808 10.3143 0.0474887 9.69411 0.0474887 9.69411L7.43764 18.1838C9.44022 20.473 10.4892 20.7591 12.7305 20.9018C14.9711 21.0452 19.9299 20.9978 23.3149 20.7591C26.9859 20.473 32.2309 19.2806 35.7592 16.5145C37.5231 15.0836 39.0961 13.1283 39.4776 10.9818Z",
  fill: "#54BBFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.424 21.0932C39.0487 18.1838 39.9542 16.3239 39.9542 16.3239C39.9542 16.3239 41.6707 29.7255 24.0777 34.5901C18.6901 36.0686 6.48391 35.353 4.52933 35.353H0L7.53287 26.9594C9.53545 24.6702 10.5844 24.1926 12.8258 24.1926C15.0663 24.1926 20.2632 24.4314 23.124 24.1454C28.3688 23.6685 32.4687 22.3328 34.424 21.0932Z",
  fill: "#148EE1"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(WistiaIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;